import { Palette, Package, Shapes, Type } from 'lucide-react';
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Separator } from '../ui/separator';

interface AssetTab {
    label: string;
    path: string;
    icon: React.ElementType;
}

export function AssetTabs() {
    const { identifier } = useParams<{ identifier: string }>();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    if (!identifier) return null;

    const basePath = `/brands/${identifier}`;

    const versionParam = searchParams.get('version');

    const assetTabs: AssetTab[] = [
        { label: 'Collections', path: `${basePath}/collections`, icon: Package },
        { label: 'Colors', path: `${basePath}/colors`, icon: Palette },
        { label: 'Fonts', path: `${basePath}/fonts`, icon: Type },
        { label: 'Stickers', path: `${basePath}/stickers`, icon: Shapes },
    ];

    return (
        <div className="border-b bg-card">
            <div className="flex items-center gap-1 overflow-x-auto px-6">
                {assetTabs.map((tab, index) => {
                    const Icon = tab.icon;
                    const isActive = location.pathname === tab.path;
                    const tabPath = versionParam ? `${tab.path}?version=${versionParam}` : tab.path;

                    const showSeparator = index === 1;

                    return (
                        <div key={tab.label} className="flex items-center">
                            {showSeparator && <Separator orientation="vertical" className="mx-2 h-8" />}
                            <Link
                                to={tabPath}
                                className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
                                    isActive
                                        ? 'border-primary text-primary'
                                        : 'border-transparent text-muted-foreground hover:border-muted hover:text-foreground'
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                {tab.label}
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
